module.exports = __webpack_public_path__ + "static/img/14000479.70ee3be6.png";